import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import { businessInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-800 text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <img
              src={businessInfo.logo}
              alt={businessInfo.name}
              className="h-24 w-auto mb-4 bg-white rounded-lg p-2"
            />
            <p className="text-slate-300 text-sm leading-relaxed">
              Providing compassionate therapy services to help individuals, couples, and families discover their inner strength and build meaningful connections.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-teal-400">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-slate-300 hover:text-teal-400 transition-colors text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-slate-300 hover:text-teal-400 transition-colors text-sm">
                  About Me
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-slate-300 hover:text-teal-400 transition-colors text-sm">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/testimonials" className="text-slate-300 hover:text-teal-400 transition-colors text-sm">
                  Testimonials
                </Link>
              </li>
              <li>
                <Link to="/resources" className="text-slate-300 hover:text-teal-400 transition-colors text-sm">
                  Resources
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-slate-300 hover:text-teal-400 transition-colors text-sm">
                  Getting Started
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-teal-400">Contact</h4>
            <ul className="space-y-3">
              <li>
                <a href={`tel:${businessInfo.phone}`} className="flex items-start gap-3 text-slate-300 hover:text-teal-400 transition-colors text-sm">
                  <Phone className="h-4 w-4 mt-0.5 flex-shrink-0" />
                  <span>{businessInfo.phone}</span>
                </a>
              </li>
              <li>
                <a href={`mailto:${businessInfo.email}`} className="flex items-start gap-3 text-slate-300 hover:text-teal-400 transition-colors text-sm">
                  <Mail className="h-4 w-4 mt-0.5 flex-shrink-0" />
                  <span>{businessInfo.email}</span>
                </a>
              </li>
              <li>
                <div className="flex items-start gap-3 text-slate-300 text-sm">
                  <MapPin className="h-4 w-4 mt-0.5 flex-shrink-0" />
                  <span>
                    Wallace House Suite C<br />
                    336 Cumberland Street<br />
                    {businessInfo.address.city}, {businessInfo.address.state} {businessInfo.address.zip}
                  </span>
                </div>
              </li>
            </ul>
          </div>

          {/* Office Hours */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-teal-400">Office Hours</h4>
            <p className="text-slate-300">By Appointment Only</p>
            <p className="text-slate-400 text-sm mt-2">Contact us to schedule your session</p>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-400 text-sm">
              © {currentYear} {businessInfo.name}. All rights reserved.
            </p>
            <p className="text-slate-500 text-xs">
              Confidentiality & privacy are paramount in our practice.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
